/* global yii */
(function ($) {
    'use strict';

    /**
     * Custom file input with a list of selected files
     * @returns {jQuery}
     */
    $.fn.file = function () {
        var $container = $(this);
        var $form = $container.closest('form');
        var $label = $container.find('label');
        var $initialInput = $container.find('input[type="file"]');
        var currentInputIndex = 0;

        // Check for DataTransfer methods support
        var supportsDataTransfer = true;
        try {
            new DataTransfer();
        } catch (err) {
            supportsDataTransfer = false;
        }

        /**
         * Clone original input and append it to label with new ID
         */
        var appendInputCloneToLabel = function () {
            $initialInput
                .clone()
                .attr('id', $initialInput.attr('id') + '-' + currentInputIndex++)
                .appendTo($label);
        };

        /**
         * Get file size string with unit in human-readable format
         * @param {number} size - file size in bytes
         * @returns {string}
         */
        var getFileSizeWithUnit = function (size) {
            var units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];
            var power = 0; // initial unit set to Bytes
            var resultSize = size;
            while (resultSize > 1024 && power < units.length) {
                resultSize = resultSize / 1024;
                power++;
            }
            return Number(resultSize.toFixed(2)) + ' ' + units[power];
        };

        /**
         * Get jQuery object array with non-empty inputs
         * @returns {jQuery[]}
         */
        var getNonEmptyInputs = function () {
            return $container.find('input[type="file"]').filter(function (index, el) {
                return !!el.files.length; // get only non-empty inputs
            });
        };

        /**
         * Get array of files from all inputs
         */
        var getFileArray = function () {
            var fileArray = [];
            var $inputs = getNonEmptyInputs();

            $inputs.each(function (index, fileInput) {
                if (fileInput.files.length) {
                    for (var i = 0; i < fileInput.files.length; i++) {
                        fileInput.files[i].inputIndex = index; // linking each file to certain input
                        fileInput.files[i].index = i; // saving file index
                        fileArray.push(fileInput.files[i]);
                    }
                }
            });

            return fileArray;
        };

        /**
         * Validate files
         */
        var validateFiles = function() {
            var fileArray = getFileArray();
            var acceptedTypes = $initialInput.get(0).accept.split(',');
            var totalFileSize = 0;
            var isCorrectType = true;
            var lastIncorrectFileName = '';
            var errorMessageArray = [];

            fileArray.forEach(function(file) {
                totalFileSize += file.size;
                if (acceptedTypes.indexOf('.' + file.name.split('.').pop().toLowerCase()) === -1) {
                    isCorrectType = false;
                    lastIncorrectFileName = file.name;
                }
            });

            if (fileArray.length > 20) {
                errorMessageArray.push('Превышено максимальное количество файлов. Доступно не более 20.');
            }
            if (totalFileSize > 1024 * 1024 * 20) {
                errorMessageArray.push('Превышен максимально допустимый суммарный размер файлов. Не более 20 мб.');
            }
            if (!isCorrectType) {
                errorMessageArray.push(lastIncorrectFileName + ' имеет недопустимый формат.');
            }

            $form.yiiActiveForm('updateAttribute', $initialInput.attr('id'), errorMessageArray.length ? errorMessageArray : '');
        };

        /**
         * Generate file list markup
         */
        var renderFileList = function () {
            // File list container
            var $fileList = $container.find('.js-file-list');

            // Clear existing container
            $fileList.empty();

            getFileArray().forEach(function (file) {
                $('<li>', {
                    class: 'file-list-item js-file-list-item',
                    append: [
                        $('<svg class="file-icon"><use xlink:href="#ic_file"></use></svg>'),
                        $('<span>', {
                            class: 'file-name',
                            text: file.name,
                            title: file.name
                        }),
                        $('<span>', {
                            class: 'file-size',
                            text: getFileSizeWithUnit(file.size)
                        }),
                        $('<button>', {
                            class: 'file-remove js-file-remove',
                            type: 'button',
                            html: '<svg><use xlink:href="#ic_close"></use></svg>',
                            data: {
                                'file-index': file.index,
                                'input-index': file.inputIndex
                            }
                        })
                    ]
                }).appendTo($fileList);
            });

            validateFiles();
        };

        /**
         * Initialization
         */
        var init = function () {
            // Clear input on page load
            $initialInput.val('').data('index', 0);

            // Allow selecting only 1 file per input if there is no support for DataTransfer methods
            $initialInput.prop('multiple', supportsDataTransfer);

            appendInputCloneToLabel();

            /**
             * Event listeners
             */
            // Added files to an empty input
            $container.on('change', function (e) {
                if ($(e.target).is('input[type="file"]')) {
                    // Move non-empty input to container element, and create new empty input
                    $(e.target).appendTo($container);
                    appendInputCloneToLabel();
                    renderFileList();
                }
            });

            // Click 'remove' button on file list element
            $container.on('click', '.js-file-remove', function () {
                var $t = $(this);
                var $inputs = getNonEmptyInputs();

                if (supportsDataTransfer) {
                    // If we can manipulate individual files in multi-file input
                    var dt = new DataTransfer();

                    // Exclude removed file from array of all files in certain input
                    var filteredFileArray = getFileArray().filter(function (file) {
                        var isTargetInput = file.inputIndex === $t.data('input-index');
                        var isTargetFile = file.index === $t.data('file-index');
                        return isTargetInput && !isTargetFile;
                    });

                    if (filteredFileArray.length) {
                        // If resulting array is not empty - put files from it into corresponding input ...
                        filteredFileArray.forEach(function (file) {
                            dt.items.add(file);
                        });
                        $inputs.eq($t.data('input-index')).get(0).files = dt.files;
                    } else {
                        // ... otherwise - remove corresponding input
                        $inputs.eq($t.data('input-index')).remove();
                    }
                } else {
                    // If only one file is allowed for each input - remove corresponding input
                    $inputs.eq($t.data('input-index')).remove();
                }

                renderFileList();
            });
        };

        // Initialize with initial conditions
        init();

        this.getFileArray = getFileArray;
        this.renderFileList = renderFileList;
        return this;
    };
})(jQuery);
